import { render } from "./VerifyEmailPage.vue?vue&type=template&id=45e158b0"
import script from "./VerifyEmailPage.vue?vue&type=script&lang=js"
export * from "./VerifyEmailPage.vue?vue&type=script&lang=js"

import "./VerifyEmailPage.vue?vue&type=style&index=0&id=45e158b0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__